export const CIAN_SOCIAL_EMAIL_REGEXP = /.+(@social.cian.ru)/i;

export const VALIDATION_ERRORS = {
  required: 'Укажите email',
  isCianSocial: 'Попробуйте другой email',
  incorrectFormat: 'Укажите корректный email',
} as const;
